<template>
    <div class="overlay">
      <div class="content payment">
        <div class="title">
          <div class="text-center"></div>
          Authenticator Code
        </div>
        <div class="pin_inputs">
          <input
            ref="pinOne"
            type="password"
            v-model="pinOne"
            @input="handleInput($event, 'pinOne', 'pinTwo')"
            @keydown="handleKeydown($event, 'pinOne')"
            maxlength="1"
            class="pin-input"
            :class="!pinOne ? 'disabled' : ''"
          />
          <input
            ref="pinTwo"
            type="password"
            v-model="pinTwo"
            @input="handleInput($event, 'pinTwo', 'pinThree')"
            @keydown="handleKeydown($event, 'pinTwo', 'pinOne')"
            maxlength="1"
            class="pin-input"
            :class="!pinTwo ? 'disabled' : ''"
          />
          <input
            ref="pinThree"
            type="password"
            v-model="pinThree"
            @input="handleInput($event, 'pinThree', 'pinFour')"
            @keydown="handleKeydown($event, 'pinThree', 'pinTwo')"
            maxlength="1"
            class="pin-input"
            :class="!pinThree ? 'disabled' : ''"
          />
          <input
            ref="pinFour"
            type="password"
            v-model="pinFour"
            @input="handleInput($event, 'pinFour', 'pinFive')"
            @keydown="handleKeydown($event, 'pinFour', 'pinThree')"
            maxlength="1"
            class="pin-input"
            :class="!pinFour ? 'disabled' : ''"
          />
          <input
            ref="pinFive"
            type="password"
            v-model="pinFive"
            @input="handleInput($event, 'pinFive', 'pinSix')"
            @keydown="handleKeydown($event, 'pinFive', 'pinFour')"
            maxlength="1"
            class="pin-input"
            :class="!pinFive ? 'disabled' : ''"
          />
          <input
            ref="pinSix"
            type="password"
            v-model="pinSix"
            @input="handleInput($event, 'pinSix', null)"
            @keydown="handleKeydown($event, 'pinSix', 'pinFive')"
            maxlength="1"
            class="pin-input"
            :class="!pinSix ? 'disabled' : ''"
          />
        </div>
        <div class="payment_btn">
          <div @click="cancelOverlay">Cancel</div>
          <div :class="isCompleted ? '' : 'disabledbtn'" @click="isCompleted && submitPin()">
            Submit
          </div>
        </div>
      </div>
      <div class="content payment info_container" v-if="loading"
        style="
          display: flex;
          flex-direction: column;
          gap: 20px;
          justify-content: center;
          align-items: center;
          min-height: 300px;
        "
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512"
          style="height: 40px; width: 40px"
          class="rolling-icon"
        >
          <path
            d="M304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM48 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm464-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM142.9 437A48 48 0 1 0 75 369.1 48 48 0 1 0 142.9 437zm0-294.2A48 48 0 1 0 75 75a48 48 0 1 0 67.9 67.9zM369.1 437A48 48 0 1 0 437 369.1 48 48 0 1 0 369.1 437z"
            style="fill: red"
          />
        </svg>
      </div>
    </div>
</template>
  
<script>
  export default {
    name: "Dashboard",
    props: {
      list: {
        type: Array,
        default: () => [],
      },
      type: {
        type: String,
        default: "airtime",
      },
      tvData: {
        type: Object,
        default: ()=>{},
      },
    },
    data() {
      return {
        loading: false,
        pinOne: "",
        pinTwo: "",
        pinThree: "",
        pinFour: "",
        pinFive: "",
        pinSix: "",
      };
    },
    computed: {
      completedPin() {
        return this.pinOne + this.pinTwo + this.pinThree + this.pinFour + this.pinFive + this.pinSix;
      },
      isCompleted() {
        return this.completedPin.length === 6;
      }
    },
    methods: {
        handleInput(event, currentPin, nextPin) {
            const value = event.target.value;
            if (!/^\d*$/.test(value)) {
                event.target.value = this[currentPin];
                return;
            }
            this[currentPin] = value;
            if (value && nextPin) {
                this.$nextTick(() => {
                this.$refs[nextPin].focus();
                });
            }
        },
        handleKeydown(event, currentPin, previousPin) {
        if (event.key === "Backspace" && !this[currentPin] && previousPin) {
            this.$nextTick(() => {
            this.$refs[previousPin].focus();
            });
        }
        },
        cancelOverlay() {
            this.$emit('cancel');
        },
        submitPin() {
            if (this.completedPin.length === 6) {
                this.$emit('completed', this.completedPin);
            }
        },
    },
  };
</script>

<style scoped lang="scss">
.amount_container {
display: flex;
flex-direction: column;
text-align: right;
gap: 8px;
.amount {
    font-size: 18px;
    font-weight: 900;
}
.available {
    font-size: 14px;
    color: #828282;
    text-transform: uppercase;
}
}
.rolling-icon {
animation: spin 2s linear infinite;
}
@keyframes spin {
0% {
    transform: rotate(0deg);
}
100% {
    transform: rotate(360deg);
}
}
.navigation {
display: flex;
justify-content: center;
align-items: center;
gap: 10px;
margin-top: 20px;
svg {
    color: red;
}
}
.disabled {
    cursor: not-allowed !important;
    opacity: 0.5;
}
.disabledbtn {
    cursor: not-allowed !important;
    opacity: 0.5;
}
.overlay {
position: fixed;
top: 0;
right: 0;
height: 100vh;
width: 100vw;
background-color: rgba(0, 0, 0, 0.5);
z-index: 1000;
display: flex;
justify-content: center;
align-items: center;
font-family: Lato !important;
}
.company_logo {
height: 56px;
width: 56px;
object-fit: contain;
}
.content {
background: #ffffff;
border-radius: 8px;
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
gap: 30px;
padding: 50px;
min-width: 450px;
position: relative;
@media screen and (max-width: 600px) {
    min-width: 0;
    width: 95%;
    padding: 20px;
    .company_logo {
    height: 32px !important;
    width: 32px !important;
    }
    .account {
    .info {
        .name {
        font-size: 14px !important;
        }
        .number_status,
        .number,
        .status {
        font-size: 12px !important;
        }
    }
    }
    .amount_container {
    .amount {
        font-size: 14px !important;
    }
    .available {
        font-size: 12px !important;
    }
    }
}
}
.vnuban {
padding-top: 30px !important;
padding-bottom: 30px !important;
.title {
    color: #495255;
    font-family: Lato;
    font-weight: 700;
    font-size: 24px;
    line-height: 100%;
    letter-spacing: -3%;
    text-align: center;
}
.main_content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 20px;
    width: 100%;
}
.bg_pink {
    background: #e00b5b0d;
    border-radius: 14px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    align-items: center;
}
.main_content .bg_pink > div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 50px;
    padding: 0px 20px;
}
.main_content .bg_pink > div:not(:last-child) {
    border-bottom: 1.64px solid #e00b5b0d;
}
.action_btn {
    height: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    background: #e00b5b;
    border-radius: 8px;
    color: #ffffff;
    font-family: Lato;
    font-weight: 700;
    font-size: 16px;
    line-height: 100%;
    letter-spacing: -3%;
    text-align: center;
    transition: all 0.5s ease-in;
    cursor: pointer;
}
.action_btn:hover {
    transform: scale(0.95);
}
.item_title {
    color: #9a9fa3;
    font-weight: 500;
    font-size: 16.4px;
    line-height: 100%;
    letter-spacing: 0%;
}
.item_text {
    color: #495255;
    font-weight: 700;
    font-size: 19.68px;
    line-height: 100%;
    letter-spacing: 2%;
    text-align: right;
    display: flex;
    gap: 4px;
    align-items: center;
}
.item_text svg {
    cursor: pointer;
}
.timer {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 4px;
    font-family: Lato;
    font-weight: 500;
    font-size: 10.55px;
    line-height: 100%;
    letter-spacing: 0%;
}
.timer span {
    color: #f58634;
    font-weight: 700;
}
}
.payment.content {
padding-top: 0px !important;
padding-left: 0px !important;
padding-right: 0px !important;
padding-bottom: 20px !important;
border-radius: 16px !important;
}
.payment {
.payment_btn {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;
    background-color: inherit;
    display: grid;
    grid-template-columns: 1fr 1fr;
    justify-content: center;
    align-items: center;
    height: fit-content;
    width: 100%;
    padding-left: 20px !important;
    padding-right: 20px !important;
}
.title {
    color: #4c4c4c;
    font-family: Lato;
    font-weight: 700;
    font-size: 20px !important;
    line-height: 100%;
    letter-spacing: 0%;
    width: 100%;
    position: relative;
    display: flex;
    justify-content: center;
    padding: 20px;
    align-items: center;
    border-bottom: 1px solid #dddddd;
    height: 60px;
}
.payment_btn > div {
    height: 45px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.5s ease-in-out;
}
.payment_btn > div:hover {
    transform: scale(0.95);
}
.payment_btn > div:first-child {
    background-color: #6a696a1f;
    border-radius: 4px;
    color: #828282;
    font-family: Lato;
    font-weight: 500;
    font-size: 14px;
    line-height: 100%;
    letter-spacing: 0%;
    text-align: center;
}
.payment_btn > div:last-child {
    background-color: #e00b5b;
    color: #ffffff;
    border-radius: 4px;
    font-family: Lato;
    font-weight: 500;
    font-size: 14px;
    line-height: 100%;
    letter-spacing: 0%;
    text-align: center;
}
.form_item {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
    padding: 0px 20px;
}
.form_item label {
    color: #4c4c4c;
    font-weight: 400;
    font-size: 16.75px;
    line-height: 125%;
    letter-spacing: 0%;
    vertical-align: bottom;
}
.form_item select,
.form_item input {
    height: 58px;
    border: 1px solid #d8dadc;
    border-radius: 12px;
    padding: 0px 20px;
    color: #4c4c4c;
    outline: none;
    width: 100%;
}
}
.content.reserved_accounts {
gap: 10px !important;
}
.search_account_container {
display: flex;
justify-content: center;
align-items: center;
padding: 0px 20px;
width: 100%;
}
.total_reserved{
font-size: 22px;
font-weight: 700;
text-align: left;
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
width: 100%;
padding: 0px 20px;
gap: 4px;
>span:first-child{
    font-size: 14px;
}
}
.reserved_accounts {
.search_account {
    outline: none;
    border: 1px solid #d8dadc;
    width: 100%;
    border-radius: 8px;
    height: 48px;
    padding: 0px 20px;
}
.account_list {
    display: flex;
    flex-direction: column;
    width: 100%;
    max-height: 450px;
    overflow-y: auto;
}
.account_list .account {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 20px;
    border-radius: 5px;
    width: 100%;
    cursor: pointer;
    transition: all 0.5s ease-in-out;
}
.account_list .account:hover {
    background-color: #f8f9fa;
}
.account_list .account .details {
    display: flex;
    align-items: center;
    gap: 8px;
    height: 100%;
}
.account_list .account .info .name {
    color: #465467;
    font-family: Lato;
    font-weight: 700;
    font-size: 18px;
    line-height: 120%;
    letter-spacing: 0%;
    vertical-align: middle;
}
.account_list .account .info {
    display: flex;
    flex-direction: column;
    gap: 8px;
}
.account_list .account .info .number_status {
    display: flex;
    align-items: center;
    gap: 8px;
}
.account_list .account .info .number_status .number {
    color: #465467;
    font-family: Lato;
    font-weight: 400;
    font-size: 18px;
    line-height: 120%;
    letter-spacing: 0%;
    vertical-align: middle;
}
.account_list .account .info .number_status .status {
    height: 20px;
    background: #0398550f;
    border-radius: 8px;
    padding: 4px 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #039855;
    font-family: Lato;
    font-weight: 400;
    font-size: 13.85px;
    line-height: 120%;
    letter-spacing: 0%;
    vertical-align: middle;
}
}
.info_container {
.processing_btn {
    background-color: #f58634 !important;
}
.info_content {
    padding-top: 24px !important;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 12px;
}
.message {
    color: #4c4c4c;
    font-family: Lato;
    font-weight: 500;
    font-size: 24px;
    line-height: 100%;
    letter-spacing: 0%;
}
.long_message {
    color: #6c6c6c;
    font-family: Lato;
    font-weight: 400;
    font-size: 14px;
    line-height: 128%;
    letter-spacing: 0%;
    text-align: center;
}
.payment_btn {
    padding-bottom: 14px;
}
.pin_inputs {
    padding: 0px 20px;
    width: fit-content;
}
.pin_inputs input {
    width: 50px;
    height: 50px;
    font-size: 24px;
    text-align: center;
    margin: 0 5px;
    border: 1px solid #e00b5b;
    outline: none;
    border-radius: 8px;
}
.info_content.pin {
    gap: 24px !important;
}
.pin .message {
    color: #4c4c4c;
    font-family: Lato;
    font-weight: 500;
    font-size: 24px;
    line-height: 100%;
    letter-spacing: 0%;
}
}
input.disabled{
    border: 1px solid rgba(0, 0, 0, 0.425) !important;
}
</style>
